<template>
  <div class="table table-hover">
    <b-breadcrumb>
      <b-breadcrumb-item>USTED ESTA AQUI</b-breadcrumb-item>
      <b-breadcrumb-item active>Documentos</b-breadcrumb-item>
    </b-breadcrumb>
    <h2 class="page-title">Documentos - <span class="fw-semi-bold">CORPOLEX</span></h2>
    <b-row>
      <b-col>
        <Widget
          title=""
          customHeader settings close
        >
          <div class="table-resposive">
            <table class="table">
              <thead>
                <tr>
                  <th class="hidden-sm-down">#</th>
                  <th>DOCUMENTO</th>
                  <th style="width:400px">DESCRIPCION</th>
                 <th class="hidden-sm-down">LINK</th>
                  <th class="hidden-sm-down">Fecha</th>
                  <th class="hidden-sm-down">Tamaño</th>
                  <th class="hidden-sm-down">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in tableStyles" :key="row.id">
                  <td>{{row.id}}</td>
                  <td>
                    <a href="https://drive.google.com/open?id=1JA3nFKxoNPwERTozEqHGnIoIauUvUiJQ" rel="nofollow noopener noreferrer" target="_blank"><img  class="img-rounded" :src="row.picture" alt="" height="50" /></a>
                  </td>
                  <td>
                    {{row.description}}
                    <div v-if="row.label">
                      <b-badge :variant="row.label.colorClass">{{row.label.text}}</b-badge>
                    </div>
                  </td>
                  <td><a href="https://drive.google.com/open?id=1JA3nFKxoNPwERTozEqHGnIoIauUvUiJQ" rel="nofollow noopener noreferrer" target="_blank">Ver</a></td>
                  <td class="text-semi-muted">
                    {{parseDate(row.date)}}
                  </td>
                  <td class="text-semi-muted">
                    {{row.size}}
                  </td>
                  <td style="text-align:center" class="width-1">

                  <span v-if="row.progress.percent > 50" class='circle bg-success mr-sm' style='font-size: 10px;'></span>
                  <span v-else class='circle bg-danger mr-sm' style='font-size: 10px;'></span>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
         
        </Widget>
      </b-col>
    </b-row>
  
  </div>
</template>

<script>
import $ from 'jquery';
import Vue from 'vue';
import Widget from '@/components/Widget/Widget';
import 'imports-loader?jQuery=jquery,this=>window!jquery-sparkline'; // eslint-disable-line

export default {
  name: 'Tables',
  components: { Widget },
  data() {
    return {
      tableStyles: [
        {
          id: 1,
          picture: require('../../assets/images/pdf_logo.png'), // eslint-disable-line global-require
          description: 'Documento de prueba tipo PDF',
          info: {
            type: 'WORD',
            dimensions: '200x150',
          },
          date: new Date('Marzo 14, 2019'),
          size: '45.6 KB',
          progress: {
            percent: 60,
            colorClass: 'success',
          },
        },
        {
          id: 2,
          picture: require('../../assets/images/excel_logo.png'), // eslint-disable-line global-require
          description: 'Documento de prueba tipo Excel',
          label: {
            colorClass: 'danger',
            text: 'LEER URGENTE!',
          },
          info: {
            type: 'PSD',
            dimensions: '2400x1455',
          },
          date: new Date('Noviembre 14, 2018'),
          size: '15.3 MB',
          progress: {
            percent: 33,
            colorClass: 'warning',
          },
        },
        {
          id: 3,
          picture: require('../../assets/images/power_point_logo.png'), // eslint-disable-line global-require
          description: 'Documento de prueba tipo Power Point',
          info: {
            type: 'JPEG',
            dimensions: '200x150',
          },
          date: new Date('Junio 14, 2019'),
          size: '49.0 KB',
          progress: {
            percent: 55,
            colorClass: 'inverse',
          },
        },
        {
          id: 4,
          picture: require('../../assets/images/infogram_logo.jpg'), // eslint-disable-line global-require
          description: 'Documento de prueba tipo Infogram',
          info: {
            type: 'PNG',
            dimensions: '210x160',
          },
          date: new Date('September 15, 2019'),
          size: '69.1 KB',
          progress: {
            percent: 90,
            colorClass: 'danger',
          },
        },
        {
          id: 5,
          picture: require('../../assets/images/word_logo.png'), // eslint-disable-line global-require
          description: 'Documento de prueba tipo Word',
          info: {
            type: 'JPEG',
            dimensions: '1452x1320',
          },
          date: new Date('October 1, 2018'),
          size: '2.3 MB',
          progress: {
            percent: 41,
            colorClass: 'primary',
          },
        },
        {
          id: 6,
          picture: require('../../assets/images/jpeg_logo.jpg'), // eslint-disable-line global-require
          description: 'Documento de prueba tipo Imágen',
          info: {
            type: 'JPGE',
            dimensions: '1452x1320',
          },
          date: new Date('Mayo 1, 2019'),
          size: '1.8 MB',
          progress: {
            percent: 41,
            colorClass: 'primary',
          },
        },
      ],
      checkboxes1: [false, false, false, false],
      checkboxes2: [false, false, false, false, false, false],
      checkboxes3: [false, false, false, false, false, false],
    };
  },
  methods: {
    parseDate(date) {
      const dateSet = date.toDateString().split(' ');
      return `${date.toLocaleString('en-us', { month: 'long' })} ${dateSet[2]}, ${dateSet[3]}`;
    },
    checkAll(ev, checkbox) {
      const checkboxArr = (new Array(this[checkbox].length)).fill(ev.target.checked);
      Vue.set(this, checkbox, checkboxArr);
    },
    changeCheck(ev, checkbox, id) {
      this[checkbox][id] = ev.target.checked;
      if (!ev.target.checked) {
        this[checkbox][0] = false;
      }
    },
    getRandomData() {
      const result = [];

      for (let i = 0; i <= 8; i += 1) {
        result.push(Math.floor(Math.random() * 20) + 1);
      }

      return result;
    },
    initCharts() {
      const colors = ['#547fff', '#9964e3', '#f55d5d', '#ffc247', '#3abf94'];

      $.each($('.sparkline-chart'), (id, chart) => {
        $(chart).sparkline(this.getRandomData(), {
          type: 'bar',
          barColor: colors[Math.floor(Math.random() * colors.length)],
        });
      });
    },
  },
  mounted() {
    this.initCharts();
  },
};
</script>

<style src="./Documentos.scss" lang="scss" scoped />
